import { StandardTabsV2 } from '@cimplico/components';
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SectionType, ListType } from '../../../types/custom-worksheet-v2';
import { selectSchema } from './store/selectors';
import { CWState, setCurrentTab } from './store/slice';

function SchemaTabs(): JSX.Element {
    const schema = useSelector((state: { schema: CWState }) => selectSchema({ state, filter: 'all' }));
    const selectedTab = useSelector((state: { schema: CWState }) => state.schema.currentTab);
    const currentFocusField = useSelector((state: { schema: CWState }) => state.schema.currentFocusFieldId?.id);

    const dispatch = useDispatch();

    // Get all groups or lists
    const blocks = useMemo(
        () =>
            Object.values(schema.properties)
                .filter((property) => property.type === SectionType.SECTION_GROUP || property.type === ListType.LIST)
                .sort((a, b) => (a.order > b.order ? 1 : -1)),
        [schema.properties]
    );

    const currentIdx = blocks.findIndex((b) => b.id === selectedTab) + 1;

    function handleChange(idx: number): void {
        dispatch(setCurrentTab({ id: idx === 0 ? undefined : blocks[idx - 1]?.id }));
    }

    useEffect(() => {
        if (!selectedTab || !currentFocusField) {
            return;
        }

        // Check overlap with any block id
        const targetBlock = blocks.find((b) => currentFocusField.startsWith(b.id));
        if (targetBlock) {
            dispatch(setCurrentTab({ id: targetBlock.id }));
        } else {
            dispatch(setCurrentTab({ id: undefined }));
        }
    }, [blocks, currentFocusField, dispatch, selectedTab]);

    return (
        <div className="w-full overflow-auto z-10">
            <StandardTabsV2 name="calculation-groups" selectedIndex={currentIdx} onChange={handleChange} pill overflow colorMode="light">
                <StandardTabsV2.Tab key={'all'} label={'All'} />
                {blocks.map((block) => (
                    <StandardTabsV2.Tab key={block.id} label={block.name} />
                ))}
            </StandardTabsV2>
        </div>
    );
}

export default SchemaTabs;
